import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';

const useStyles = makeStyles()((theme: Theme) =>
  ({
    content: {
      flexGrow: 1,
      padding: theme.spacing(2),
      '.embedded-layout__container &': {
        padding: 0,
      },
    },
  })
);

export function AreaContent(props: BoxProps) {
  const { classes } = useStyles();
  const { className, ...rest } = props;
  const defaults = {
    className: clsx(classes.content, className),
  };

  return <Box {...{ ...defaults, ...rest }} />;
}
